import _ from 'lodash';

import * as AppActions from './AppActions.js';
import { t } from '../../locales';

const currencySymbols = {
  gbp: '£',
  usd: '$',
};

const initialState = {
  isLoggingIn: false,
  loginError: null,
  error: null,
  language: null,
  authToken: null,
  businessInfo: null,
  locations: null,
  location: null,
  intakeForms: null,
  customFields: null,
  serviceProviderTerm: 'Service Provider',
};

export default function appointment(state = initialState, action) {
  switch (action.type) {
    case 'UNAUTHORIZED':
      return {
        ...initialState,
      };
    case 'LOGOUT':
      return {
        ...initialState,
      };
    case AppActions.SET_ERROR:
      return {
        ...state,
        error: action.data,
      };
    case AppActions.SET_LANGUAGE:
      return {
        ...state,
        language: action.data,
      };
    case AppActions.SET_LOGIN_ERROR:
      return {
        ...state,
        loginError: action.data,
        isLoggingIn: false,
      };
    case AppActions.SET_LOGGING_IN:
      return {
        ...state,
        loginError: null,
        isLoggingIn: action.data,
      };
    case AppActions.LOAD_AUTH_TOKEN:
      localStorage.setItem('authToken', action.data);

      return {
        ...state,
        authToken: action.data,
        isLoggingIn: false,
        loginError: null,
      };
    case AppActions.LOAD_BUSINESS_INFO: {
      return {
        ...state,
        businessInfo: {
          ...action.data,
          currencySymbol:
            currencySymbols[_.get(action.data, 'company.currency_uuid', 'usd')] || '$',
        },
      };
    }
    case AppActions.LOAD_DURATIONS:
      return {
        ...state,
        durations: action.data,
      };
    case AppActions.LOAD_LOCATIONS:
      return {
        ...state,
        locations: action.data,
      };
    case AppActions.LOAD_LOCATION:
      localStorage.setItem('location', JSON.stringify(action.data));

      return {
        ...state,
        location: action.data,
      };
    case AppActions.LOAD_PRINTER_MAC:
      localStorage.setItem('printerMac', JSON.stringify(action.data));

      return {
        ...state,
        printerMac: action.data,
      };
    case AppActions.LOAD_INTAKE_FORMS:
      return {
        ...state,
        intakeForms: action.data.intake_forms,
      };
    case AppActions.LOAD_CUSTOM_FIELDS:
      return {
        ...state,
        customFields: action.data.custom_fields.filter(cf => cf.type !== 'MyClient::CustomField::ClientSinceDate'),
      };
    default:
      return state;
  }
}

export function getIsFamilyMemberAccount(businessInfo) {
  if (
    businessInfo.company.child_type === 'family_member' ||
    businessInfo.company.child_type === 'pet' ||
    businessInfo.company.child_type === 'vehicle'
  )
    return true;
  else return false;
}

export function getFamilyMemberTerm(businessInfo) {
  if (businessInfo.company.child_type === 'family_member')
    return t('app_reducer.family_member');
  else if (businessInfo.company.child_type === 'pet')
    return t('app_reducer.pet');
  else if (businessInfo.company.child_type === 'vehicle')
    return t('app_reducer.vehicle');
  else return t('app_reducer.person');
}

export function getShortFamilyMemberTerm(businessInfo) {
  if (businessInfo.company.child_type === 'family_member')
    return t('app_reducer.family_member');
  else if (businessInfo.company.child_type === 'pet')
    return t('app_reducer.pet');
  else if (businessInfo.company.child_type === 'vehicle')
    return t('app_reducer.vehicle');
  else return t('app_reducer.person');
}

export function getIsServiceAvailableForClient(businessInfo) {
  if (businessInfo.company.child_type === 'pet') return false;
  if (businessInfo.company.child_type === 'vehicle') return false;
  else return true;
}

export function getIntakeFields(allIntakeForms, allCustomFields, mandatory) {
  const intakeForms = allIntakeForms ? allIntakeForms : [];
  const customFields = allCustomFields ? allCustomFields : [];

  const ifis = intakeForms
    .filter(
      inf =>
        (inf.mandatory ? inf.mandatory : false) === mandatory || inf.mandatory
    ) // added || inf.mandatory to handle old clients
    .reduce(
      (t, intakeForm) => [
        ...t,
        ...intakeForm.intake_form_items.map(i => ({
          ...i,
          mandatory: intakeForm.mandatory,
          variations: intakeForm.intake_form_variations.map(
            ifv => ifv.variation_id
          ),
        })),
      ],
      []
    );

  const fields = ifis
    .map(ifi => ({
      ...ifi,
      custom_field: customFields.find(cf => cf.id === ifi.custom_field_id),
    }))
    .filter(itf => itf.custom_field)
    .sort((f1, f2) => f1.sort_order - f2.sort_order);

  return fields;
}
